import { Component, Input, OnInit } from '@angular/core';
import { PetitumRevisione } from "../../../models/petitum-revisione";
import { SezioneEconomica } from "../../../models/sezioni/sezione-economica";
import { UtilityCommon } from "../../../utils/utility-common";

@Component({
  selector: 'app-fondo-rischi-view',
  templateUrl: './fondo-rischi-view.component.html',
  styleUrls: ['./fondo-rischi-view.component.css']
})
export class FondoRischiViewComponent implements OnInit {
  @Input() sezione: SezioneEconomica;
  @Input() lastRevisioneFondoRischi: PetitumRevisione;
  @Input() isQuantificabile: boolean;
  calcolaSomma = UtilityCommon.calcolaSomma;
  constructor() { }

  ngOnInit() {
    console.log(this.lastRevisioneFondoRischi)
  }

  sommaFondoRischiControparteAttr(attr) {
    let somma = 0;
    if(this.lastRevisioneFondoRischi && this.lastRevisioneFondoRischi.fondorischiControparti){
      this.lastRevisioneFondoRischi.fondorischiControparti.forEach(el => {
        somma += el[attr];
      });
    }
    return this.approssimaImporto(somma);
  }

  approssimaImporto(importo): number {
    let num = Number(importo);
     return Math.trunc(100*num)/100;
  }

  // approssimaTotale(importo):number{
  //   let num=Number(importo);
  //   return (Math.abs(num-Math.round(num))<0.1) ? Math.round(num) : num;
  // }

  parseTotale(totale: string){
    while(totale.indexOf('.')>-1){
      totale = totale.replace('.','');
    }
    return totale;
  }
}

